/**************************************************
 * Nombre:       Tarjeta_Servicios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {WhatsApp} from '@mui/icons-material'
import {iniciarCharWass} from "../../Utilidades/iniciarCharWass";
import {useBotonWass} from "../../Modulo_Boton_Wass/Hooks/useBotonWass";

const Tarjeta_Servicios = ({item}) => {
    const {abrir, Vista} = useBotonWass()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Vista/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} width={'100%'} height={'auto'} alt={'item.nombre'} style={{borderRadius: 10}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography
                    sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        lineHeight: 1.1
                    }}

                >
                    {item.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography
                    sx={{
                        fontSize: 16,
                        fontWeight: 300,
                        lineHeight: 1.4
                    }}

                >
                    {item.descripcion}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Button
                    onClick={(e) => abrir(e.target)}
                    variant={'outlined'} startIcon={<WhatsApp/>}>Contactar</Button>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Servicios    